const aspectEn = {
	aspectTable: 'Aspect',
	aspectEditForm: 'Aspect',
	name: 'Name',
	description: 'Description',
	driver: 'Driver',
	model: 'Model',
	dataset: 'Dataset',
	basic: 'Basic',
	inputAttributes: 'Input Attributes',
	outputAttributes: 'Output Attributes',
	type: 'Type',
	value: 'Value',
	attribute_class: 'Attribute class',
	model_field_name: 'Model field name',
	state: 'State',
	values: 'Values',
	reader: 'Reader',
	summary_type: 'Summary type',
	summary_duration: 'Summary duration',
	summary_duration_type: 'Summary duration type',
	minified: 'Minified',
	modelFieldName: 'Model field name',
	attributeClass: 'Attribute class',
	transformer: 'Transformer',
	userGroup: 'User Group'
};

export default aspectEn;
